export const START_IMPORT_CATALOG = '[IMPORT_CATALOG] Start Import Catalog';
export const TRACK_IMPORT_PROGRESS = '[IMPORT_CATALOG] Track Import Progress';
export const TRACK_IMPORT_PROGRESS_ERROR =
  '[IMPORT_CATALOG] Track Import Progress Error';
export const TRACK_IMPORT_PROGRESS_SUCCESS =
  '[IMPORT_CATALOG] Track Import Progress Success';
export const IMPORT_CATALOG_SUCCESS = '[IMPORT_CATALOG] Import Catalog Success';
export const IMPORT_CATALOG_ERROR = '[IMPORT_CATALOG] Import Catalog Error';
